<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-brand">
          <img class="footer-logo" src="@/assets/img/foot_logo.png" alt="KOMA Logo" />
          <p class="footer-slogan">{{ translations[locale].slogan }}</p>
        </div>

        <div class="footer-links">
          <div class="footer-column">
            <h3 class="footer-title">{{ translations[locale].product.title }}</h3>
            <ul class="footer-list">
              <li><a href="#">{{ translations[locale].product.architecture }}</a></li>
              <li><a href="#">{{ translations[locale].product.docs }}</a></li>
              <li><a href="#">{{ translations[locale].product.api }}</a></li>
            </ul>
          </div>
        </div>

        <div class="footer-links">

          <div class="footer-column">
            <h3 class="footer-title">{{ translations[locale].resources.title }}</h3>
            <ul class="footer-list">
              <li><a href="#">{{ translations[locale].resources.blog }}</a></li>
              <li><a href="#">{{ translations[locale].resources.community }}</a></li>
              <li><a href="#">{{ translations[locale].resources.help }}</a></li>
            </ul>
          </div>
        </div>

        <div class="footer-links">

          <div class="footer-column">
            <h3 class="footer-title">{{ translations[locale].contact.title }}</h3>
            <ul class="footer-list">
              <li><a href="#">{{ translations[locale].contact.twitter }}</a></li>
              <li><a href="#">{{ translations[locale].contact.discord }}</a></li>
              <li><a href="#">{{ translations[locale].contact.telegram }}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright">{{ translations[locale].copyright }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from '@/stores/language'

const store = useStore()
const locale = computed(() => store.locale)

const translations = {
  zh: {
    slogan: '打造下一代區塊鏈基礎設施',
    product: {
      title: '產品',
      architecture: '科技架構',
      docs: '開發檔案',
      api: 'API參攷'
    },
    resources: {
      title: '資源',
      blog: '博客',
      community: '社區',
      help: '幫助中心'
    },
    contact: {
      title: '聯繫我們',
      twitter: 'Twitter',
      discord: 'Discord',
      telegram: 'Telegram'
    },
    copyright: ' ©  2024 KOMA.保留所有權利。 '
  },
  en: {
    slogan: 'Building the next generation blockchain infrastructure',
    product: {
      title: 'Product',
      architecture: 'Technical Architecture',
      docs: 'Developer Docs',
      api: 'API Reference'
    },
    resources: {
      title: 'Resources',
      blog: 'Blog',
      community: 'Community',
      help: 'Help Center'
    },
    contact: {
      title: 'Contact Us',
      twitter: 'Twitter',
      discord: 'Discord',
      telegram: 'Telegram'
    },
    copyright: '© 2024 KOMA. All rights reserved.'
  }
}
</script>



<style lang="scss" scoped>
.footer {
  background: #111827;
  padding: 48px 0;
  color: #9CA3AF;
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-content {
  display: grid;
  grid-template-columns: 284px repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 32px;
}

.footer-brand {
  .footer-logo {
    // width: 284px;
    height: 85px;
    // object-fit: cover;
    // margin-bottom: 24px;
  }

  .footer-slogan {
    font-size: 1rem;
    line-height: 1.5;
  }
}

.footer-column {
  .footer-title {
    color: #FFFFFF;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 16px;
  }
}

.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      color: #9CA3AF;
      text-decoration: none;
      font-size: 1rem;
      line-height: 1.5;
      transition: color 0.3s ease;

      &:hover {
        color: #FFFFFF;
      }
    }
  }
}

.footer-bottom {
  border-top: 1px solid #1F2937;
  padding-top: 32px;
  text-align: center;
}

.footer-copyright {
  font-size: 1rem;
  line-height: 1.5;
}

// 响应式设计
@media screen and (max-width: 1200px) {
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 48px;
  }

  .footer-brand {
    grid-column: 1 / -1;
    text-align: center;

    .footer-logo {
      margin: 0 auto 24px;
    }
  }
}

@media screen and (max-width: 768px) {
  .footer {
    padding: 40px 0;
  }

  .footer-container {
    padding: 0 16px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .footer-column {
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .footer {
    padding: 32px 0;
  }

  .footer-brand {
    .footer-logo {
      width: 200px;
      height: auto;
    }
  }
}

// 深色模式支持
@media (prefers-color-scheme: dark) {
  .footer {
    background: #0F172A;
  }

  .footer-bottom {
    border-color: #1E293B;
  }
}
</style>